<template>
    <div class="row container-fluid" v-if="singleUser.first_name !== undefined">
      <v-layout row wrap>
        <v-flex lg4 md4 sm12 xs12>
          <v-card flat>
            <v-container>
                <div class="panel-body">
                  <h2 class="earth-color"><a href="">{{singleUser.first_name}} {{singleUser.last_name}}</a></h2>
                  <p></p>
                </div>
                <div class="panel-body">
                  <dl>
                    <dt>User Type</dt>
                    <dd>{{singleUser.user_type}}</dd>
                    <dt>Registration Date</dt>
                    <dd>{{formated_date_time(singleUser.registered_on)}}</dd>
                    
                    <!-- Wallet Balance -->
                    <dt>Wallet Balance (USD)</dt>
                    <dd class="balance-usd">$ {{ formatPrice(singleUser.wallet_balance_usd || 0) }}</dd>
                    
                    <dt>Wallet Balance (KES)</dt>
                    <dd class="balance-kes">KSh {{ formatPrice(singleUser.wallet_balance_kes || 0) }}</dd>
                  </dl>
                  <br>
                  <br>
                  
                  <!-- Action Buttons -->
                  <v-btn :depressed="true" color="error" v-if="singleUser.active_status === 'Active'" @click="suspendUser()">Suspend ({{suspend_count}})</v-btn>
                  <v-btn :depressed="true" color="info" v-if="singleUser.active_status === 'Suspended'" @click="unsuspendUser()">Activate ({{suspend_count}})</v-btn>
                  
                  <!-- Transactions Button -->
                  <v-btn :depressed="true" color="#587e27" @click="viewWalletTransactions()" class="ml-2">
                    <v-icon small left>account_balance_wallet</v-icon>
                    Transactions
                  </v-btn>
                  
                  <!-- Bookings Button - Use route with user_id and pass email as query -->
                  <v-btn :depressed="true" color="#2980b9" @click="viewUserBookings()" class="ml-2">
                    <v-icon small left>bookmark</v-icon>
                    Bookings
                  </v-btn>
                </div>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex lg8 md8 sm12 xs12>
          <add-user></add-user>
        </v-flex>
      </v-layout>
      {{UpdateUser}}
    </div>
</template>

<script>
import AddUser from './AddUser'
export default {
  components: { AddUser },
  data () {
    return {
      suspend_count: 3,
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      user: {
        user_type: '',
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        user_id: this.$route.params.user_id
      }
    }
  },
  methods: {
    updateUser: function () {
      this.$store.dispatch('update_user', this.user)
    },
    formatPrice: function(price) {
      if (!price && price !== 0) return '0.00'
      return parseFloat(price).toLocaleString('en-KE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    viewWalletTransactions: function() {
      this.$router.push({
        name: 'UserWalletTransactions',
        params: { user_id: this.$route.params.user_id }
      })
    },
    viewUserBookings: function() {
      // Use user_id in params and pass email as query
      this.$router.push({
        name: 'UserBookings',
        params: { 
          user_id: this.$route.params.user_id 
        },
        query: { 
          user_email: this.singleUser.email,
          user_name: this.singleUser.first_name + ' ' + this.singleUser.last_name
        }
      })
    },
    suspendUser: function () {
      if (this.suspend_count > 0) {
        this.suspend_count = this.suspend_count - 1
      } else {
        this.$store.dispatch('suspend_user', this.$route.params.user_id)
      }
    },
    unsuspendUser: function () {
      if (this.suspend_count > 0) {
        this.suspend_count = this.suspend_count - 1
      } else {
        this.$store.dispatch('unsuspend_user', this.$route.params.user_id)
      }
    }
  },
  created () {
    this.$store.dispatch('get_user', this.$route.params.user_id)
    this.$store.dispatch('get_all_user_types')
  }
}
</script>

<style scoped>
.balance-usd {
  color: #111315ff;
  font-weight: 600;
}

.balance-kes {
  color: #27ae60;
  font-weight: 600;
}
</style>